var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/x-wiki-full.ts
import { getByID } from "@adornis/baseql/operations/mongo.js";
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element.js";
import { RXController } from "@adornis/chemistry/controllers/RXController.js";
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import { XDialog } from "@adornis/dialog/x-dialog.js";
import { routingState } from "@adornis/router/client/routing-state.js";
import { html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { takeUntil } from "rxjs";
import { WikiEntry } from "../db/WikiEntry.js";
import { WikiEntryDraft } from "../db/WikiEntryDraft.js";
import "./x-wiki-editor.js";
import "./x-wiki-view.js";
var XWikiFull = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.entryID = new RXController(this, "");
    this.hideEdit = false;
    this.hideDelete = false;
    this._initParam = new RXController(this, routingState.searchParams.get("edit"));
    this._inEdit = new RXController(this, false);
  }
  connectedCallback() {
    super.connectedCallback();
    this.entryID.observable.pipe(takeUntil(this.disconnected)).subscribe((id) => {
      if (["true", "1"].includes(this._initParam.value ?? "") && !this.hideEdit) {
        return;
      }
      this._inEdit.next(false);
    });
    this._initParam.observable.pipe(takeUntil(this.disconnected)).subscribe((edit) => {
      if (!edit) {
        return;
      }
      this._inEdit.next(["true", "1"].includes(edit) && !this.hideEdit);
    });
    this._inEdit.observable.pipe(takeUntil(this.disconnected)).subscribe((inEdit) => {
      if (inEdit) {
        routingState.searchParams.delete("jumpTo");
      }
    });
  }
  handleEntryNavigate(e) {
    this.dispatchEvent(
      new CustomEvent("entry-navigate", {
        detail: {
          value: e.detail.value,
          edit: e.detail.edit
        }
      })
    );
  }
  render() {
    if (this._inEdit.value) {
      return xComponents(html`<x-flex padding="lg">
        <x-wiki-editor
          .entryID=${this.entryID.value}
          @entry-saved=${() => this._inEdit.next(false)}
          @entry-abort=${() => this._inEdit.next(false)}
          @entry-created=${this.handleEntryNavigate}
          @entry-navigate=${this.handleEntryNavigate}
        ></x-wiki-editor>
      </x-flex>`);
    }
    return xComponents(html`<x-wiki-view .entryID=${this.entryID.value} @entry-navigate=${this.handleEntryNavigate}>
      <x-flex slot="title-right" horizontal space="sm">
        ${!this.hideEdit ? html`<x-button tone="accent" icon="edit" mode="icon" @click=${() => this._inEdit.next(true)}></x-button>` : ""}
        ${!this.hideDelete ? html`
              <x-button
                tone="error"
                icon="delete"
                mode="icon"
                @click=${() => {
      XDialog.guard(
        async () => {
          const res = await getByID(
            WikiEntry,
            this.entryID.value
          )({
            _class: 1,
            _id: 1,
            referenceID: 1
          });
          const wasDraft = res?._class === WikiEntryDraft._class;
          const referenceID = res?.referenceID;
          await res?.remove();
          this.dispatchEvent(
            new CustomEvent("entry-deleted", {
              detail: {
                value: this.entryID.value
              }
            })
          );
          if (wasDraft) {
            this.dispatchEvent(
              new CustomEvent("entry-navigate", {
                detail: {
                  value: referenceID
                }
              })
            );
          }
        },
        {
          hasToConfirm: true,
          confirmText: "Wirklich l\xF6schen? Alle Drafts dieses Eintrages werden auch gel\xF6scht."
        }
      );
    }}
              ></x-button>
            ` : ""}
      </x-flex>
    </x-wiki-view>`);
  }
};
__decorateClass([
  property()
], XWikiFull.prototype, "entryID", 2);
__decorateClass([
  property({ type: Boolean, attribute: "hide-edit" })
], XWikiFull.prototype, "hideEdit", 2);
__decorateClass([
  property({ type: Boolean, attribute: "hide-delete" })
], XWikiFull.prototype, "hideDelete", 2);
__decorateClass([
  state()
], XWikiFull.prototype, "_initParam", 2);
__decorateClass([
  state()
], XWikiFull.prototype, "_inEdit", 2);
XWikiFull = __decorateClass([
  customElement("x-wiki-full")
], XWikiFull);
export {
  XWikiFull
};
